export const PRODUCT_SCREENSHOTS = {
  signups: {
    src: "/screenshots/signups-cart.png",
    alt: "My Signups with a held entry and Pay now",
  },
  payments: {
    src: "/screenshots/card-payments.png",
    alt: "Signup Dashboard with Paid, Held, Due, and Mark paid",
  },
  scoring: {
    src: "/screenshots/scoring-sheet.png",
    alt: "Scoring sheet with games posted",
  },
  brackets: {
    src: "/screenshots/brackets-tree.png",
    alt: "An 8-player bracket tree after Game 3",
  },
  payouts: {
    src: "/screenshots/finance-payouts.png",
    alt: "Finance payout table",
  },
  averages: {
    src: "/screenshots/averages-verify.png",
    alt: "Averages with Verify on unverified bowlers",
  },
  overview: {
    src: "/screenshots/tournament-overview.png",
    alt: "Overview for Cedar Ridge Handicap Doubles with final standings posted",
  },
  averageImport: {
    src: "/screenshots/ai-average-import.png",
    alt: "Extracted league averages from a photo, ready to review",
  },
  signupImportReview: {
    src: "/screenshots/ai-signup-review.png",
    alt: "A reviewed signup row opened to create the team",
  },
  signupImportResults: {
    src: "/screenshots/ai-signup-results.png",
    alt: "Signup sheet import with teams ready to review",
  },
  recapImport: {
    src: "/screenshots/ai-recap-import.png",
    alt: "Recap games on the team after the filled sheet is matched",
  },
};

/*
 * No-org AI Assist shots live in public/screenshots/ai-*.png.
 * Still needed before new image slots:
 * - check export template / print preview
 * - software hub / weekend board overview
 * Do not borrow Signups, Averages, Scoring, Finance, or Overview shots for those.
 * Do not use older captures that show an organization name.
 */
